import {
  createContext,
  useContext as useContextOrigin,
} from 'react';
import { Parser } from 'bowser';

export interface IAppContext {
  identity: {
    type: string;
    param: string;
    code: string;
  },
  location: {
    pathname: string,
  },
  bowser: Parser.ParsedResult,
  mode: 'preview' | '',
  pages?: number[] | null,
}

export const AppContext = createContext({
  identity: {
    type: '',
    param: '',
    code: '',
  },
  location: {
    pathname: '',
  },
  bowser: {},
  mode: '',
  pages: null,
} as IAppContext);

export const useAppContext = (): IAppContext => {
  const {
    identity,
    location,
    bowser,
    mode,
    pages,
  } = useContextOrigin(AppContext);
  return {
    identity,
    location,
    bowser,
    mode,
    pages,
  };
};
